<h2 mat-dialog-title>Select Bands</h2>

<mat-dialog-content class="dialog-content band-selector-content">
  <!-- Search -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchText" (input)="filterBands()" />
  </mat-form-field>

  <!-- Scrollable List -->
  <div class="apply-note">Selected bands will be applied to all scenes.</div>

  <div class="list-wrapper mat-elevation-z1">
    <cdk-virtual-scroll-viewport itemSize="48" class="viewport">
      <div *cdkVirtualFor="let band of filteredBands" class="band-row">
        <mat-checkbox
          color="primary"
          [checked]="isSelected(band.id)"
          [disabled]="isDisabled(band.id)"
          (change)="toggleBand(band.id)"
        >
          {{ band.label }}
        </mat-checkbox>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  <!-- Selected -->
  <div class="selected-section">
    <div class="selected-title">
      Selected ({{ selectedBands.length }}/{{ maxSelection }})
    </div>

    <mat-chip-list>
      <mat-chip
        *ngFor="let band of selectedBands"
        color="primary"
        selected
        removable
        (removed)="toggleBand(band.id)"
      >
        {{ band.label }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" class="custom-button">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    (click)="apply()"
    [disabled]="!canApply()"
  >
    Apply
  </button>
</mat-dialog-actions>
